import React, { useEffect, useState } from "react";
import { Typography, Grid2, CardContent, Button, useMediaQuery } from "@mui/material";
// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Icons } from "../../config/MuiIcons.config";
import noImage from "../../assets/images/no-img-selected.jpg";
import {
  APP_MESSAGE,
  FORM_VALIDATIONS,
  SNACKBAR_VARIANT,
  USE_FORMIK_SCHEMA,
} from "../../config/Messages.config";
import "./UserProfile.style.css";
import {
  extractFirstName,
  generateRandomId,
  getPlusSignInCountryCode,
} from "../../common/CommonFunctions";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";
import {
  getUserRoleAndScreens,
} from "../../services/authServices/auth.services";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { useBackdrop } from "../../contexts/BackDrop.context";
import {
  getCompanyInformation,
  updateCompanyInformation,
} from "../../helpers/api-functions-helper";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUIErrorText from "../../components/MUIErrorText/MUIErrorText";
import ImageThumbnail from "../../common/ImageThumbnail/ImageThumbnail";
import { AppTheme } from "../../theme/App.theme";
import { uploadImageHandler } from "../../common/UploadImage/uploadImageHandler";
import { CLOUD_STOAGE } from "../../config/CloudStorage.config";
import ImagePreview from "../../common/ImagePreview/ImagePreview";
import MUILoader from "../../components/MUILoader/MUILoader";
import ChangePasswordModal from "./ChangePasswordModal";
import CountryCodeDropdown from "../../components/CommonReusableComponent/CountryCodeDropdown/CountryCodeDropdown";

const UserProfile = () => {
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const isMobileMid = useMediaQuery("(max-width:520px)");
  const authUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  );
  const { role, accountId } = getUserRoleAndScreens();
  // Check weather logged-in user is super-admin
  const isSuperAdmin =
    role && role.toLowerCase() === "superadmin" ? true : false;
  // Check weather logged-in user is zingworks-admin
  const isZingworksAdmin =
    role && role.toLowerCase() === "zingworks" ? true : false;

  document.title = "User Profile | Zing Auditor";
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    email: "",
  });
  const [isCompanyDetailsLoading, setIsCompanyDetailsLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  // Company logo state
  const [image_url, setImage_Url] = useState(null);
  const [file, setFile] = useState(null);
  const [imageUploadError, setImageUploadError] = useState("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [previewImage, setPreviewImage] = useState({
    isVisible: false,
    image: null,
  });

  // Change Password
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
  // Function toggle change password modal
  const toggleChangePasswordModal = () => {
    setIsChangePasswordModalOpen(e => !e)
  }

  // Funtion to toggle edit mode
  const toggleEditMode = () => {
    setIsEditMode((e) => !e);
  };

  // Function used to get company information
  const fetchCompanyInformation = () => {
    if (isSuperAdmin) {
      setIsCompanyDetailsLoading(true);
      getCompanyInformation(accountId)
        .then((response) => {
          if (response && response.data) {
            const { statusCode, data, message, success } = response.data;
            if (success && statusCode === 200) {
              setCompanyDetails(data[0]);
            } else {
              showSnackbar(
                message || data || APP_MESSAGE.COMPANY_MASTER.FETCHED.FAILED,
                SNACKBAR_VARIANT.ERROR
              );
            }
          }
        })
        .catch((error) => {
          console.log("Error: ", error);
          showSnackbar(
            APP_MESSAGE.COMPANY_MASTER.FETCHED.FAILED,
            SNACKBAR_VARIANT.ERROR
          );
        })
        .finally(() => {
          setIsCompanyDetailsLoading(false);
        });
    }
  };

  // Function to update company information
  const updateCompanyDetails = (Data) => {
    showBackdrop();
    updateCompanyInformation(Data)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, message, success } = response.data;
          if (success && statusCode === 200) {
            showSnackbar(
              APP_MESSAGE.COMPANY_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            setIsEditMode(false);
            fetchCompanyInformation();
          } else {
            showSnackbar(
              message || data || APP_MESSAGE.COMPANY_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.COMPANY_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        hideBackdrop();
      });
  };

  useEffect(() => {
    const authUser = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
    );
    if (authUser) {
      const profileName =
        authUser?.displayName || extractFirstName(authUser?.email);
      setUserDetails({
        email: authUser.email,
        firstName: profileName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage]);

  useEffect(() => {
    fetchCompanyInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleResetPasswordOfUser = () => {
  //   handlePasswordReset(userDetails.email)
  //     .then((res) => {
  //       showSnackbar(
  //         "Change password link has been sent to your registered email.",
  //         "success"
  //       );
  //     })
  //     .catch((error) => {
  //       console.log("Error: ", error);
  //       showSnackbar("Something went wrong, please try again.", "error");
  //     });
  // };

  const UploadImageToFirebase = () => {
    return new Promise((resolve, reject) => {
      setIsImageUploading(true);
      showBackdrop();
      setImageUploadError("");
      var firebaseImageName = `image-${generateRandomId(20)}.${
        file?.name.split(".")[1]
      }`;
      var image_storagePath = CLOUD_STOAGE.ACCOUNT_MASTER;
      uploadImageHandler(
        image_storagePath,
        firebaseImageName,
        file,
        (url) => {
          resolve(url);
          // console.log("url: ", url);
          setImage_Url(url);
        },
        setIsImageUploading,
        (status) => {
          if (status.isError) {
            reject(new Error(status.message));
            hideBackdrop();
          }
        },
        () => setFile(null)
      );
    });
  };

  // Function to handle the complete flow: upload image and then create/update PPE
  const handleSubmitForm = async (values) => {
    try {
      let firebase_URL = image_url;
      if (file && firebase_URL?.includes("blob")) {
        firebase_URL = await UploadImageToFirebase();
      }

      if (firebase_URL) {
        const payload = {
          data: {
            ...values,
            abbreviation: values.abbreviation.trim(),
            name: values.name.trim(),
            address: values.address.trim(),
            logo: firebase_URL,
          },
          accountId: accountId,
          companyId: companyDetails?.id,
        };
        // console.log("payload: ", payload);
        updateCompanyDetails(payload);
      }
    } catch (error) {
      console.error("Image upload failed: ", error);
      showSnackbar(
        error.message || APP_MESSAGE.COMPANY_MASTER.LOGO_UPLOAD.FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    }
  };

  // Function used to handle select image input
  const handleChangeImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      var u = URL.createObjectURL(file);
      var img = new Image();
      img.src = u;
      setFile(file);
      setImage_Url(u);
      setImageUploadError("");
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (companyDetails && companyDetails?.name) || "",
      email: (companyDetails && companyDetails?.email) || "",
      phoneNumber: (companyDetails && companyDetails?.phoneNumber) || "",
      abbreviation: (companyDetails && companyDetails?.abbreviation) || "",
      address: (companyDetails && companyDetails?.address) || "",
      phoneNumberCountryCode:
        (companyDetails && companyDetails?.phoneNumberCountryCode) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.TEXT_INPUT.REGEX.INITIAL,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.NAME),
      email: Yup.string()
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.EMAIL)
        .email(USE_FORMIK_SCHEMA.COMPANY_DETAILS.EMAIL),
      phoneNumber: Yup.string()
        .matches(
          FORM_VALIDATIONS.NUMBER_INPUT.REGEX,
          FORM_VALIDATIONS.NUMBER_INPUT.MESAAGE
        )
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.PHONE_NUMBER),
      abbreviation: Yup.string()
        .trim()
        .matches(
          FORM_VALIDATIONS.UNIQUE_PREFIX.REGEX,
          FORM_VALIDATIONS.UNIQUE_PREFIX.MESSAGE
        )
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.ABBRIVATIONS),
      address: Yup.string()
        .trim()
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.ADDRESS),
      phoneNumberCountryCode: Yup.string()
        .required(USE_FORMIK_SCHEMA.COMPANY_DETAILS.COUNTRY_CODE),
    }),
    onSubmit: (values) => {
      // console.log("values: ", values);
      if (image_url !== null) {
        handleSubmitForm(values);
      } else {
        setImageUploadError("Please upload image");
      }
    },
  });

  useEffect(() => {
    if (companyDetails) {
      setImage_Url(companyDetails?.logo);
    }
  }, [companyDetails]);

  return (
    <React.Fragment>
      {isChangePasswordModalOpen && (
        <ChangePasswordModal
          ModalState={isChangePasswordModalOpen}
          OnSubmit={() => {}}
          Title={"Change Password"}
          ToggleFunction={toggleChangePasswordModal}
        />
      )}
      <div className="my-2">
        {previewImage.isVisible && (
          <ImagePreview
            ImageUrl={previewImage.image}
            TogglePreview={() => {
              setPreviewImage((e) => ({
                ...e,
                isVisible: false,
                image: null,
              }));
            }}
          />
        )}
        <Grid2 container className="mb-3">
          <Card sx={{ width: "100%", padding: "10px" }}>
            <CardContent>
              <Grid2 container alignItems="center" justifyContent="flex-start" spacing={2}>
                <Grid2>
                  <Icons.UserProfileIcon className="user-profile-icon-css" />
                </Grid2>
                <Grid2>
                  <Typography
                    variant="h6"s
                    component="div"
                    className="inter-regular-400"
                    style={{ textTransform: "capitalize" }}
                    noWrap
                  >
                    {userDetails && userDetails.firstName}
                  </Typography>
                  <Typography
                    className="inter-regular-400"
                    style={{ fontSize: "14px" }}
                    noWrap
                  >
                    {userDetails && userDetails.email}
                  </Typography>
                  {!isSuperAdmin && !isZingworksAdmin && (
                    <Typography
                      className="inter-regular-400 my-1"
                      style={{ fontSize: "14px" }}
                      noWrap
                    >
                      {`Company Name: ${authUser?.companyName}`}
                    </Typography>
                  )}
                </Grid2>
                <Grid2 className={!isMobileMid ? "ms-auto" : ""}>
                  <Link
                    href="#"
                    onClick={toggleChangePasswordModal}
                    className="inter-regular-400"
                    style={{ fontSize: "14px", color: AppTheme.PRIMARY_COLOR }}
                  >
                    Change Password
                  </Link>
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>
        </Grid2>

        {isSuperAdmin && (
          <Grid2 container className="mt-4">
            <Card sx={{ width: "100%", padding: "10px" }}>
              {isCompanyDetailsLoading ? (
                <MUILoader />
              ) : (
                <>
                  <div className="d-flex align-items-center">
                    <Typography className="inter-medium-500 text-dark ps-3">
                      Company Details
                    </Typography>
                    {!isEditMode && (
                      <div className="ms-auto">
                        <Button
                          variant="contained"
                          className="inter-regular-400"
                          size="small"
                          startIcon={
                            <Icons.EditIcon style={{ fontSize: "14px" }} />
                          }
                          style={{
                            backgroundColor: AppTheme.PRIMARY_COLOR,
                            color: AppTheme.WHITE,
                            textTransform: "capitalize",
                          }}
                          onClick={toggleEditMode}
                        >
                          Edit
                        </Button>
                      </div>
                    )}
                  </div>
                  <CardContent
                  // style={{ border: "1px solid #D9D9D9", borderRadius: 5 }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={{xs: 12, sm: 12, md: 5}}>
                        <Typography
                          variant="body2"
                          className="inter-medium-500 py-2"
                        >
                          {isEditMode ? "Enter Comapany Name" : "Company Name"}
                        </Typography>
                        {isEditMode ? (
                          <AppInputField
                            Name={"name"}
                            Id={"name"}
                            Type={"text"}
                            Value={validation.values.name || ""}
                            OnBlur={validation.handleBlur}
                            OnChange={validation.handleChange}
                            PlaceHolder={"Enter company name"}
                            Error={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                            HelperText={
                              validation.touched.name &&
                              validation.errors.name ? (
                                <MUIErrorText
                                  ErrorMessage={validation.errors.name}
                                />
                              ) : null
                            }
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            className="inter-regular-400"
                          >
                            {companyDetails?.name}
                          </Typography>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, sm: 12, md: 5}}>
                        <Typography
                          variant="body2"
                          className="inter-medium-500 py-2"
                        >
                          {isEditMode
                            ? "Enter Comapany Email"
                            : "Company Email"}
                        </Typography>
                        {isEditMode ? (
                          <AppInputField
                            Name={"email"}
                            Id={"email"}
                            Type={"email"}
                            Value={validation.values.email || ""}
                            OnBlur={validation.handleBlur}
                            OnChange={(e) => {
                              const { value, name } = e.target;
                              validation.handleChange({
                                ...e,
                                target: {
                                  ...e.target,
                                  name: name,
                                  value: value.toLowerCase(),
                                },
                              });
                            }}
                            PlaceHolder={"Enter company email"}
                            Error={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                            HelperText={
                              validation.touched.email &&
                              validation.errors.email ? (
                                <MUIErrorText
                                  ErrorMessage={validation.errors.email}
                                />
                              ) : null
                            }
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            className="inter-regular-400"
                          >
                            {companyDetails?.email}
                          </Typography>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, sm: 12, md: 2}}>
                        <Typography
                          variant="body2"
                          noWrap
                          className="inter-medium-500 py-2"
                        >
                          {isEditMode ? "Enter Unique Prefix" : "Unique Prefix"}
                        </Typography>
                        {isEditMode ? (
                          <AppInputField
                            Name={"abbreviation"}
                            Id={"abbreviation"}
                            Type={"text"}
                            Value={validation.values.abbreviation || ""}
                            OnBlur={validation.handleBlur}
                            OnChange={(e) => {
                              const { value, name } = e.target;
                              validation.handleChange({
                                ...e,
                                target: {
                                  ...e.target,
                                  name: name,
                                  value: value.toUpperCase(),
                                },
                              });
                            }}
                            PlaceHolder={"Enter unique prefix"}
                            Error={
                              validation.touched.abbreviation &&
                              validation.errors.abbreviation
                                ? true
                                : false
                            }
                            HelperText={
                              validation.touched.abbreviation &&
                              validation.errors.abbreviation ? (
                                <MUIErrorText
                                  ErrorMessage={validation.errors.abbreviation}
                                />
                              ) : null
                            }
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            className="inter-regular-400"
                          >
                            {companyDetails?.abbreviation}
                          </Typography>
                        )}
                      </Grid2>
                      {isEditMode && (
                        <Grid2 size={{xs: 12, sm: 2, md: 2}}>
                          <Typography
                            variant="body2"
                            className="inter-medium-500 py-2"
                          >
                            Country Code
                          </Typography>
                          <CountryCodeDropdown
                            Id={"phoneNumberCountryCode"}
                            Name={"phoneNumberCountryCode"}
                            PlaceHolder={"Country code"}
                            Value={
                              validation.values.phoneNumberCountryCode || ""
                            }
                            OnChange={validation.handleChange}
                            OnBlur={validation.handleBlur}
                            Error={
                              validation.touched.phoneNumberCountryCode &&
                              validation.errors.phoneNumberCountryCode
                                ? true
                                : false
                            }
                            HelperText={
                              validation.errors.phoneNumberCountryCode
                            }
                          />
                        </Grid2>
                      )}
                      <Grid2 size={{xs: 12, sm: 12, md: !isEditMode ? 5 : 3}}>
                        <Typography
                          variant="body2"
                          className="inter-medium-500 py-2"
                        >
                          {isEditMode ? "Enter Phone Number" : "Phone Number"}
                        </Typography>
                        {isEditMode ? (
                          <AppInputField
                            Name={"phoneNumber"}
                            Id={"phoneNumber"}
                            Type={"text"}
                            Value={validation.values.phoneNumber || ""}
                            OnBlur={validation.handleBlur}
                            OnChange={validation.handleChange}
                            PlaceHolder={"Enter phone number"}
                            Error={
                              validation.touched.phoneNumber &&
                              validation.errors.phoneNumber
                                ? true
                                : false
                            }
                            HelperText={
                              validation.touched.phoneNumber &&
                              validation.errors.phoneNumber ? (
                                <MUIErrorText
                                  ErrorMessage={validation.errors.phoneNumber}
                                />
                              ) : null
                            }
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            className="inter-regular-400"
                          >
                            {`${getPlusSignInCountryCode(
                              companyDetails?.phoneNumberCountryCode
                            )} ${companyDetails?.phoneNumber}`}
                          </Typography>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, sm: 12, md: 7}}>
                        <Typography
                          variant="body2"
                          className="inter-medium-500 py-2"
                        >
                          {isEditMode
                            ? "Enter Comapany Address"
                            : "Company Address"}
                        </Typography>
                        {isEditMode ? (
                          <AppInputField
                            Name={"address"}
                            Id={"address"}
                            Type={"text"}
                            IsMultiLine={true}
                            Value={validation.values.address || ""}
                            OnBlur={validation.handleBlur}
                            OnChange={validation.handleChange}
                            PlaceHolder={"Enter company address"}
                            Error={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                            HelperText={
                              validation.touched.address &&
                              validation.errors.address ? (
                                <MUIErrorText
                                  ErrorMessage={validation.errors.address}
                                />
                              ) : null
                            }
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            className="inter-regular-400"
                          >
                            {companyDetails?.address}
                          </Typography>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12}} className="d-flex align-items-center">
                        <div>
                          <Typography
                            variant="body2"
                            className="inter-medium-500 py-2"
                          >
                            Company Logo
                          </Typography>
                          <ImageThumbnail
                            IsUsedForCompanyDetails={true}
                            ImageUrl={
                              !companyDetails?.logo && !image_url
                                ? noImage
                                : image_url
                                ? image_url
                                : companyDetails?.logo
                            }
                            OnClickHandler={() => {
                              if (companyDetails?.logo || image_url) {
                                setPreviewImage({
                                  isVisible: true,
                                  image:
                                    !companyDetails?.logo && !image_url
                                      ? noImage
                                      : image_url
                                      ? image_url
                                      : companyDetails?.logo,
                                });
                              }
                            }}
                          />
                        </div>
                        {isEditMode && (
                          <div className="mt-3">
                            <input
                              type="file"
                              id="company-logo-input-img"
                              name="Image_URL"
                              accept="image/png, image/jpg, image/jpeg"
                              style={{ display: "none" }}
                              onChange={handleChangeImage}
                            />
                            <Link
                              href="#"
                              onClick={() => {
                                var inputFile = document.querySelector(
                                  "#company-logo-input-img"
                                );
                                inputFile.click();
                              }}
                              className="inter-regular-400"
                              style={{
                                fontSize: "14px",
                                color: AppTheme.PRIMARY_COLOR,
                              }}
                            >
                              Choose New Image
                            </Link>
                          </div>
                        )}
                      </Grid2>
                      {imageUploadError && isEditMode ? (
                        <MUIErrorText ErrorMessage={imageUploadError} />
                      ) : null}
                    </Grid2>
                    {isEditMode && (
                      <Grid2
                        container
                        className="mt-3"
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid2 size={{xs: 6, sm: 2}}>
                          <Button
                            type="button"
                            variant="outlined"
                            fullWidth
                            className="inter-regular-400"
                            size="medium"
                            disabled={isImageUploading}
                            style={{
                              textTransform: "capitalize",
                              color: AppTheme.PRIMARY_COLOR,
                              borderColor: AppTheme.PRIMARY_COLOR,
                            }}
                            onClick={() => {
                              toggleEditMode();
                              validation.handleReset();
                              setImageUploadError("");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid2>
                        <Grid2 size={{xs: 6, sm: 2}}>
                          <Button
                            variant="contained"
                            type="submit"
                            className="inter-regular-400"
                            fullWidth
                            size="medium"
                            disabled={isImageUploading}
                            onClick={validation.handleSubmit}
                            style={{
                              backgroundColor: AppTheme.PRIMARY_COLOR,
                              color: AppTheme.WHITE,
                              textTransform: "capitalize",
                            }}
                          >
                            Update
                          </Button>
                        </Grid2>
                      </Grid2>
                    )}
                  </CardContent>
                </>
              )}
            </Card>
          </Grid2>
        )}
        <div style={{ height: "50px" }}>
          <div className="d-flex align-items-center justify-content-center h-100">
            <Typography
              variant="body2"
              className="inter-regular-400 text-dark"
              color="inherit"
              align="center"
            >
              Powered by{" "}
              <Link
                to={"https://zingworks.in"}
                target="_blank"
                className="text-dark"
              >
                Zingworks
              </Link>
            </Typography>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
